export const ru = {
    'normal-view-title': 'Добавьте уточнения в объявления',
    'normal-view-title-hint': 'Показывается, потому что у вас есть объявления без уточнений',
    'percent-value': '{value}%',
    'popup-view-title': 'Добавьте уточнения в объявление',
    'popup-view-title-hint': 'Показывается, потому что у объявления нет уточнений',
    'show-many-banner-button': 'Посмотреть {count} объявлений',
    'show-one-banner-button': 'Посмотреть {count} объявление',
    'show-some-banner-button': 'Посмотреть {count} объявления',
    'title-extension-desc1': 'По нашим исследованиям уточнения повышают CTR объявлений на {value}.',
    'title-extension-desc2':
        'В уточнениях вы можете перечислить преимущества товара или услуги, рассказать о специальных предложениях или описать выгодные условия работы с вами.'
};
